import { GridLayout } from "../../../Models/GridLayout";

export const createParcelsHeaderGridVars = (
  layout: GridLayout,
): React.CSSProperties =>
  ({
    "--parcels-header-columns": layout.columns,
    "--parcels-header-areas": layout.areas,
  }) as React.CSSProperties;

export const createParcelsListGridVars = (
  layout: GridLayout,
): React.CSSProperties =>
  ({
    "--parcels-list-columns": layout.columns,
    "--parcels-list-areas": layout.areas,
  }) as React.CSSProperties;

export const createParcelsFooterGridVars = (
  layout: GridLayout,
): React.CSSProperties =>
  ({
    "--parcels-footer-columns": layout.columns,
    "--parcels-footer-areas": layout.areas,
  }) as React.CSSProperties;
